<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <!-- {{$store.state.user.count}} -->

    <vs-card>
      <vs-row>
        <vs-button
          v-if="canAddEmp"
          to="/pages/employee/add"
          icon-pack="feather"
          icon="icon-plus"
          color="primary"
          type="border"
          class="mb-2"
          >Adicionar Funcionário</vs-button
        >
        <vs-button
          v-if="canAddEmp"
          @click="importar = true"
          icon-pack="feather"
          icon="icon-upload"
          color="success"
          type="border"
          class="mb-2 ml-3"
          >Importar Funcionários</vs-button
        >
      </vs-row>

      <vs-table search stripe :data="employees" :max-items="paginate">
        <template slot="header">
          <!-- <vs-button v-if="canAddEmp" to="/pages/employee/add" icon-pack="feather" icon="icon-plus"  color="primary" type="border" class="mb-2">Adicionar Funcionário</vs-button> -->
          <select
            @change="getEmployees"
            class="block ml-3 pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
            v-validate="'excluded:1,2,3'"
            v-model="paginate"
            name="not_in_field"
            data-vv-as="selected"
          >
            <option class="vs__selected-options" value="5">5</option>
            <option class="vs__selected-options" value="10">10</option>
            <option class="vs__selected-options" value="20">20</option>
            <option class="vs__selected-options" value="50">50</option>
            <option class="vs__selected-options" value="100">100</option>
            <option class="vs__selected-options" value="500">500</option>
            <option class="vs__selected-options" value="1000">1000</option>
          </select>

          <!-- <v-select
          @change="getEmployees"
                 label="name"
                  :options="departments"
                  v-model="selectedDepartment"
                name="departamento"
                v-validate="'required'"
              /> -->

          <v-select
            class="ml-5 w-1/3"
            icon-pack="feather"
            label="name"
            :options="departments"
            v-model="selectedDepartment"
            @input="getEmployees"
            placeholder="Selecione um departamento"
          ></v-select>

          <vs-button
            class="ml-5"
            size=""
            @click="
              selectedDepartment = [];
              getEmployees();
            "
            >Limpar</vs-button
          >
        </template>

        <template slot="thead">
          <vs-th sort-key="name">Codigo</vs-th>
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="surname">Apelido</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
          <vs-th sort-key="gender">Departamento</vs-th>
          <vs-th></vs-th>
          <!-- <vs-th sort-key="id">Nro</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].code" class="whitespace-no-wrap">
              {{ data[indextr].code }}
            </vs-td>
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>
            <vs-td :data="data[indextr].surname">
              {{ data[indextr].surname }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].department_name">
              {{ data[indextr].department_name }}
            </vs-td>

            <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
              <vs-button
                color="success"
                size="small"
                hover:text-danger
                type="border"
                icon-pack="feather"
                icon="icon-eye"
                :to="{
                  name: 'employee-proflie',
                  params: { employeeId: data[indextr].id },
                }"
                >Visualizar</vs-button
              >

              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

            <!-- <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"
      ></div>
      <label class="ml-3 font-bold">Total: {{ total }}</label> <br />

      <vs-pagination
        class="mt-3"
        :total="totalPage"
        @change="getEmployees"
        v-model="currentPage"
      ></vs-pagination>
      <vs-button
        color="dark"
        to="/pages/employee/deleted"
        line-origin="left"
        type="line"
        >Visualizar funcionarios eliminados</vs-button
      >
    </vs-card>
    <div>
      <vs-popup
        class="holamundo"
        title="Importar funcionario"
        :active.sync="importar"
      >
        <div class="vx-row">
          <div class="vx-col w-full mb-5">
            <label for="" class="font-bold">Importar excel</label>
            <vs-input
              class="w-full mt-2 mb-2"
              type="file"
              v-model="ficheiro"
              name="file"
              accept=".csv, .xlsx"
              @change="previewImage"
            />
          </div>
        </div>

        <div class="flex flex-wrap items-end flex-start">
          <vs-button class="ml-auto mt-2" @click="saveModel"
            >Importar</vs-button
          >
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import http from "../../../../../http-common";
// Store Module

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import { mapState } from "vuex";
import { PermissionsMixin } from "../../../../mixins/permissions";

export default {
  mixins: [PermissionsMixin],
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      selectedDepartment: [],
      departments: [],
      totalPage: "",
      currentPage: "1",
      paginate: 100,
      total: "",
      importar: false,
      employees: [],
      currentUser: [],
      teste: [],
      dataNotLoading: false,
      novoValor: 20,
      ficheiro: "",
      attachment: "",
      ///////////////Permissoes//////////////////
    };
  },

  mounted() {
    this.initialize();
    this.getEmployees();
  },

  methods: {
    async initialize() {
      await this.increment();
      this.getEmployees();
      this.getDepartments();
    },
    async increment() {
      const userLogado = await this.$store._actions["user/getCurrentUser"][0];
      userLogado();
    },

    async saveModel() {
      this.$vs.loading();
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
          "content-type": "multipart/form-data",
        },
      };
      const data = new FormData();
      data.append("file", this.attachment);
      data.append("type", 1);

      await http
        .post("/employees/importEmployees", data, config)
        .then((success) => {
          success;
          (this.importar = false),
            this.getEmployees(),
            this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Importado com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Erro ao importar",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
    previewImage(event) {
      this.attachment = event.target.files[0];
    },

    getDepartments() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/companies/departments", config)
        .then((result) => {
          this.departments = result.data.Departments.reverse();
        })
        .catch((error) => {
          error;
        });
    },

    getEmployees() {
  // Inicia o loading somente se houver um departamento selecionado
  if (this.selectedDepartment) {
    this.$vs.loading({
      container: "#div-with-loading",
      scale: 1.0,
      type: "sound",
    });
  }

  let token = localStorage.getItem("token");
  let config = {
    headers: {
      authorization: "Bearer " + token,
    },
    params: {
      status: 1,
      page: this.currentPage,
      paginate: this.paginate,
      // Condicionalmente adiciona o department_id se houver um departamento selecionado
      ...(this.selectedDepartment ? { department_id: this.selectedDepartment.id } : {}),
    },
  };

  http
    .get("/employees/employees", config)
    .then((result) => {
      if (this.paginate !== this.novoValor) {
        this.currentPage = "1";
        this.novoValor = this.paginate;
      }

      // Fecha o loading caso tenha sido iniciado
      if (this.selectedDepartment) {
        this.$vs.loading.close("#div-with-loading > .con-vs-loading");
      }

      // Atualiza a lista de funcionários e outras variáveis de estado
      this.employees = result.data.Employees.data.reverse();
      this.totalPage = result.data.Employees.last_page;
      this.total = result.data.Employees.total;
      this.dataNotLoading = true;
    })
    .catch((error) => {
      // Fecha o loading em caso de erro
      if (this.selectedDepartment) {
        this.$vs.loading.close("#div-with-loading > .con-vs-loading");
      }
      this.dataNotLoading = true;

      if (error.response && error.response.status === 401) {
        this.$router.push("/").catch(() => {});
      }
    });
},

  },
};
</script>
